const URL_CANDIDATE = /(https?:\/\/[^\s<>"'`)\]}]+)/gi;

export const containsUrl = (text: string): boolean => {
  if (!text) return false;
  let found = false;

  text.replace(URL_CANDIDATE, (match) => {
    if (found) return match; // short-circuit
    const cleaned = stripTrailingPunctuation(match);
    const url = toHttpHttpsUrl(cleaned);
    if (url) found = true;
    return match;
  });

  return found;
};

/** Validate with the URL constructor and restrict protocol to http/https. */
const toHttpHttpsUrl = (candidate: string): string | null => {
  try {
    const u = new URL(candidate);
    if (u.protocol === 'http:' || u.protocol === 'https:') return u.toString();
  } catch {}
  return null;
};

/** Common case: links wrapped in punctuation (e.g., "...(https://google.com)." ) */
const stripTrailingPunctuation = (s: string): string => {
  return s.replace(/[),.;:!?]+$/g, '');
};
